import { render } from "./x.vue?vue&type=template&id=318c8346"
import script from "./x.vue?vue&type=script&lang=js"
export * from "./x.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__